var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgULogoTransp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 154.41,
    height: 185.975,
    viewBox: "0 0 154.41 185.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#07a1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1a95d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3a82c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5b6fb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#6265c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6f53e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7d51d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a44ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d34b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#dc5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f06022"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "U-logo-transp.svg",
    transform: "translate(-49.434 -62.613)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 77.205,
    cy: 3.879,
    rx: 77.205,
    ry: 3.879,
    transform: "translate(49.434 240.83)",
    opacity: 0.432,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U_path",
    "data-name": "U path",
    d: "M125.4,244.448a78.068,78.068,0,0,1-28.77-5.424,74.645,74.645,0,0,1-23.653-14.886,69.888,69.888,0,0,1-16.111-22.313A66.282,66.282,0,0,1,50.9,174.363l-.051-2.865V62.613H71.105v108.8l.051,2.859a47.676,47.676,0,0,0,15.632,35.055,57.567,57.567,0,0,0,77.218,0,47.676,47.676,0,0,0,15.632-35.055v-.121l.032-2.712V62.613h20.252V171.562l-.032,2.769a66.306,66.306,0,0,1-5.959,27.494,69.861,69.861,0,0,1-16.111,22.313,74.758,74.758,0,0,1-23.653,14.886,78.069,78.069,0,0,1-28.77,5.424Z",
    transform: "translate(-0.284)",
    fill: "url(#linear-gradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgULogoTransp);
export default __webpack_public_path__ + "static/media/U-logo-transp.540b54e77d57f2e8e9fb3e74bf3b5e65.svg";
export { ForwardRef as ReactComponent };